export const PRIMARY_CHATFLOW_TEMPLATE = 'primary-calculation-dreamplan-dk';
export const PRIMARY_CHATFLOW_TEMPLATE_VERSION = 1;
export const FLOW_BUILDER_URI_REGEX =
  /(flow-builder:\/\/(?:[a-z0-9.\-_~]+(?::\d+)?)?(?:\/[a-z0-9.\-_~]+)*(?:\.[a-z0-9-_~]+)*(?:\?(?:[a-z0-9-._~]|%[a-f0-9]|[!$&'*+,;=:]|[\/?])+)?(?:#(?:[a-z0-9-._~]|%[a-f0-9]|[!$&'*+,;=:]|[\/?])+)?)/gi;
